import apiClient from './apiClient';

// The Python network-discovery-service returns status as uppercase strings
// ("QUEUED", "ACTIVE", ...) but this page's Chip color maps and status
// comparisons use lowercase keys ('queued', 'active', ...). Without
// normalizing, every status-based color lookup silently misses (undefined
// color) and every status-based count/filter is always empty. Same class of
// bug as the Organizations page had — fixed the same way, at the service
// boundary, so components can compare against plain lowercase strings.
const normalizeStatus = (o) => ({ ...o, status: o.status?.toLowerCase() });

export async function fetchDiscoveredAssets() {
  const { data } = await apiClient.get('/network-discovery/assets');
  return data.map(normalizeStatus);
}

export async function fetchAssetChanges() {
  const { data } = await apiClient.get('/network-discovery/changes');
  return data;
}

export async function fetchDiscoveryJobs() {
  const { data } = await apiClient.get('/network-discovery/discovery/scans');
  return data.map(normalizeStatus);
}

export async function startDiscoveryScan(targetRange) {
  const { data } = await apiClient.post('/network-discovery/discovery/scan', { target_range: targetRange });
  return normalizeStatus(data);
}
